import WelcomePanelOptions from './WelcomePanelOptions'
import SubMenu from './common/SubMenu'

const WelcomePanel = () => (
    <SubMenu componentOptions={WelcomePanelOptions} />
)

export default WelcomePanel